var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.$style.success },
    [
      _c("Title", [_vm._v("感謝您的愛心")]),
      _c("hr"),
      _vm._l(_vm.fields, function (field, i) {
        return _c("FormRow", {
          key: i,
          scopedSlots: _vm._u(
            [
              {
                key: "left",
                fn: function () {
                  return [
                    _c("FormLabel", { attrs: { small: "", for: field.name } }, [
                      _vm._v(" " + _vm._s(field.label) + " "),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _c("div", {
                      class: _vm.$style.desc,
                      domProps: { innerHTML: _vm._s(_vm.getDesc(field.name)) },
                    }),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        })
      }),
      _c("hr"),
      _c("FormRow", {
        scopedSlots: _vm._u([
          {
            key: "left",
            fn: function () {
              return [
                _c("FormLabel", { attrs: { small: "" } }, [
                  _vm._v(" 請問您如何得知 TFT 相關訊息？ "),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "right",
            fn: function () {
              return [
                _c("SelectInput", {
                  attrs: {
                    id: "related-info",
                    placeholder: "請選擇",
                    value: _vm.form.relatedInfo,
                    options: ["Teach For Taiwan 官網"],
                  },
                  on: {
                    "update:value": function ($event) {
                      return _vm.$set(_vm.form, "relatedInfo", $event)
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("FormRow", {
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c("TextInput", {
                  attrs: {
                    id: "related-info",
                    placeholder: "您可以填寫從何獲得 TFT 的資訊",
                    value: _vm.form.relatedInfoCustom,
                  },
                  on: {
                    "update:value": function ($event) {
                      return _vm.$set(_vm.form, "relatedInfoCustom", $event)
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "FormRow",
        [
          _c("CheckBoxRadioInput", {
            attrs: {
              value: _vm.form.newsletter,
              label: "同意定期收到 TFT 電子報（略過步驟視為不同意）",
            },
            on: {
              "update:value": function ($event) {
                return _vm.$set(_vm.form, "newsletter", $event)
              },
            },
          }),
        ],
        1
      ),
      _c("FormRow", [_c("Button", [_vm._v("確認送出")])], 1),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }